import { render } from "./StatsBox.vue?vue&type=template&id=2e6fbb2a&scoped=true"
import script from "./StatsBox.vue?vue&type=script&lang=js"
export * from "./StatsBox.vue?vue&type=script&lang=js"

import "./StatsBox.vue?vue&type=style&index=0&id=2e6fbb2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e6fbb2a"]])

export default __exports__